import type { ReviewableCount } from "@/api/reviews";
import { getReviewableCount } from "@/api/reviews";
import { useQuery } from "@tanstack/react-query";

interface UseReviewableCountBySpecialtyOptions {
  customerIds?: string[];
  dateFrom?: string;
  dateTo?: string;
}

export function useReviewableCountBySpecialty(options?: UseReviewableCountBySpecialtyOptions) {
  const { customerIds, dateFrom, dateTo } = options ?? {};

  const { data, isLoading, error, refetch } = useQuery<ReviewableCount>({
    queryKey: ["reviewable-count-by-specialty", customerIds?.join(","), dateFrom, dateTo],
    queryFn: () =>
      getReviewableCount({
        admit_date_from: dateFrom,
        admit_date_to: dateTo,
        customer_ids: customerIds?.length ? customerIds.join(",") : undefined,
      }),
    staleTime: 30000,
    gcTime: 5 * 60 * 1000,
  });

  return { data, isLoading, error, refetch };
}
